<template>
  <!-- Click-to-play YouTube: shows the video's thumbnail and a play button, and
       loads YouTube's player (~1 MB of script per video) only when clicked.
       Size and border classes from the parent land on this root element. -->
  <div class="relative overflow-hidden bg-black">
    <iframe
      v-if="playing"
      class="absolute inset-0 w-full h-full"
      :title="title"
      :src="playSrc"
      frameborder="0"
      referrerpolicy="strict-origin-when-cross-origin"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <button
      v-else
      type="button"
      class="group absolute inset-0 w-full h-full cursor-pointer"
      :aria-label="`Play video: ${title}`"
      @click="playing = true"
    >
      <img
        :src="thumb"
        :alt="title"
        loading="lazy"
        decoding="async"
        class="w-full h-full object-cover"
      />
      <svg
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[68px] h-[48px] opacity-90 group-hover:opacity-100"
        viewBox="0 0 68 48"
        aria-hidden="true"
      >
        <path
          class="fill-[#212121] group-hover:fill-[#FF0000] transition-colors"
          d="M66.5 7.7c-.8-2.9-3-5.2-5.9-6C55.3.3 34 .3 34 .3s-21.3 0-26.6 1.4c-2.9.8-5.1 3.1-5.9 6C.1 13 .1 24 .1 24s0 11 1.4 16.3c.8 2.9 3 5.2 5.9 6C12.7 47.7 34 47.7 34 47.7s21.3 0 26.6-1.4c2.9-.8 5.1-3.1 5.9-6C67.9 35 67.9 24 67.9 24s0-11-1.4-16.3z"
          fill-opacity="0.85"
        />
        <path d="M45 24 27 14v20z" fill="#fff" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'YouTubeEmbed',
  props: {
    // YouTube embed URL, e.g. https://www.youtube.com/embed/<id> or .../embed/videoseries?list=<id>
    src: { type: String, required: true },
    title: { type: String, required: true },
    // Thumbnail image (i.ytimg.com/vi/<id>/maxresdefault.jpg or hqdefault.jpg).
    thumb: { type: String, required: true },
  },
  data() {
    return { playing: false };
  },
  computed: {
    // Start playing straight away: the visitor already clicked play once.
    playSrc() {
      return this.src + (this.src.includes('?') ? '&' : '?') + 'autoplay=1';
    },
  },
};
</script>
